import { render } from "./userDashboard.vue?vue&type=template&id=304a95a2&scoped=true"
import script from "./userDashboard.vue?vue&type=script&lang=js"
export * from "./userDashboard.vue?vue&type=script&lang=js"

import "./userDashboard.vue?vue&type=style&index=0&id=304a95a2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304a95a2"]])

export default __exports__